import React, { useContext } from 'react'
import { RegistrationFormContext } from './types'
import { InputElement } from '../../../../HtmlComponents/InputElement'
import { InputRadio } from '../../../../HtmlComponents/InputRadio'

const Section2 = () => {
  const { 
    maritalStatus, setMaritalStatus,

    conjointDateOfBirth, setConjointDateOfBirth,
    conjointPlaceOfBirth, setConjointPlaceOfBirth,
    conjointProfession, setConjointProfession,

    num_Child, setNumChild,
    militarySituation, setMilitarySituation,
   } = useContext(RegistrationFormContext)

  return (
    <>
      <section className='grid md:grid-cols-2 gap-2'>
        <div>
          <p className='font-bold text-main'>{"8) "}Situation Matrimoniale</p>
          <InputRadio 
            checked={maritalStatus === "Célibataire" ? true : false} 
            labelName='Célibataire'
            id='Célibataire' 
            value={"Célibataire"} 
            setValue={setMaritalStatus} 
          />
          <InputRadio 
            checked={maritalStatus === "Marié" ? true : false} 
            labelName='Marié'
            id='Marié' 
            value={"Marié"} 
            setValue={setMaritalStatus} 
          />
          <InputRadio 
            checked={maritalStatus === "Divorcé" ? true : false} 
            labelName='Divorcé'
            id='Divorcé' 
            value={"Divorcé"} 
            setValue={setMaritalStatus} 
          />
          <InputRadio 
            checked={maritalStatus === "Veuf" ? true : false} 
            labelName='Veuf'
            id='Veuf' 
            value={"Veuf"} 
            setValue={setMaritalStatus} 
          />
        </div>
        <div>
          <label className='font-bold text-main' htmlFor="conjoint">{"9) "}Conjoint</label>
          <InputElement type='date' name="Date de naissance" value={conjointDateOfBirth} setValue={setConjointDateOfBirth} />
          <InputElement name="Lieu de naissance" value={conjointPlaceOfBirth} setValue={setConjointPlaceOfBirth} />
          <InputElement name="Profession" value={conjointProfession} setValue={setConjointProfession} />
          {/* conjointDateOfBirth, setConjointDateOfBirth,
          conjointPlaceOfBirth, setConjointPlaceOfBirth,
          conjointProfession, setConjointProfession, */}


        </div>

      </section>
      <section className='grid md:grid-cols-2 gap-2'>
        <InputElement labelClass="text-main" name="10) Nombre d'enfants" value={num_Child} setValue={setNumChild}/>
        <div>
          <p className='font-bold text-main'>{"11) "}situation militaire</p>
          <InputRadio checked={militarySituation === "Militaire" && true} labelName='Militaire' id='Militaire' value={"Militaire"} setValue={setMilitarySituation}/>
          <InputRadio checked={militarySituation === "Civil" && true} labelName='Civil' id='Civil' value={"Civil"} setValue={setMilitarySituation}/>
        </div>
      </section>
    
    </>
  )
}

export default Section2